import { render, staticRenderFns } from "./permissionForm.vue?vue&type=template&id=5a6ef882&scoped=true"
import script from "./permissionForm.vue?vue&type=script&lang=js"
export * from "./permissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6ef882",
  null
  
)

export default component.exports